import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { LeftOutlined, RightOutlined, ReloadOutlined } from '@ant-design/icons';
import './server-summary-block.css';

const RestartIcon = () => (
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: 14, height: 14 }}>
    <g clipPath="url(#clip0_ssb_restart)">
      <path d="M6.0001 0.999894C6.66336 1.00207 7.31959 1.13576 7.93084 1.39324C8.54208 1.65071 9.09619 2.02685 9.5611 2.49989H8.0001C7.86749 2.49989 7.74032 2.55257 7.64655 2.64634C7.55278 2.74011 7.5001 2.86729 7.5001 2.99989C7.5001 3.1325 7.55278 3.25968 7.64655 3.35345C7.74032 3.44722 7.86749 3.49989 8.0001 3.49989H10.0716C10.3178 3.49976 10.5539 3.4019 10.728 3.2278C10.9021 3.0537 11 2.81761 11.0001 2.57139V0.499894C11.0001 0.367286 10.9474 0.240109 10.8537 0.14634C10.7599 0.0525723 10.6327 -0.000106158 10.5001 -0.000106158C10.3675 -0.000106158 10.2403 0.0525723 10.1465 0.14634C10.0528 0.240109 10.0001 0.367286 10.0001 0.499894V1.53889C9.17369 0.79462 8.15639 0.295099 7.06215 0.0962684C5.96791 -0.102562 4.83991 0.00714982 3.80449 0.413118C2.76907 0.819085 1.86711 1.50528 1.19961 2.39486C0.532105 3.28443 0.125422 4.34227 0.0251013 5.44989C0.0186429 5.51952 0.0267591 5.58973 0.0489327 5.65605C0.0711063 5.72237 0.106851 5.78334 0.153889 5.83509C0.200928 5.88683 0.258228 5.92821 0.32214 5.95658C0.386052 5.98496 0.455174 5.99971 0.525101 5.99989C0.647395 6.00145 0.765868 5.95731 0.857331 5.87612C0.948793 5.79492 1.00666 5.68251 1.0196 5.56089C1.13091 4.31627 1.70359 3.15825 2.62514 2.31431C3.54669 1.47038 4.75051 1.00154 6.0001 0.999894Z" fill="currentColor"/>
      <path d="M11.4756 6.00004C11.3533 5.99848 11.2349 6.04262 11.1434 6.12382C11.0519 6.20501 10.9941 6.31742 10.9811 6.43904C10.8985 7.39066 10.5446 8.2986 9.96145 9.05515C9.37831 9.8117 8.5904 10.3851 7.6912 10.7073C6.79199 11.0296 5.81922 11.0871 4.8883 10.8731C3.95738 10.6591 3.10737 10.1826 2.43912 9.50005H4.00012C4.13273 9.50005 4.25991 9.44737 4.35368 9.3536C4.44744 9.25983 4.50012 9.13266 4.50012 9.00005C4.50012 8.86744 4.44744 8.74026 4.35368 8.64649C4.25991 8.55272 4.13273 8.50005 4.00012 8.50005H1.92862C1.80667 8.49998 1.6859 8.52395 1.57322 8.57059C1.46054 8.61723 1.35816 8.68562 1.27193 8.77185C1.18569 8.85808 1.1173 8.96047 1.07067 9.07315C1.02403 9.18583 1.00006 9.3066 1.00012 9.42855V11.5001C1.00012 11.6327 1.0528 11.7598 1.14657 11.8536C1.24034 11.9474 1.36751 12.0001 1.50012 12.0001C1.63273 12.0001 1.75991 11.9474 1.85368 11.8536C1.94744 11.7598 2.00012 11.6327 2.00012 11.5001V10.4611C2.82654 11.2053 3.84383 11.7048 4.93807 11.9037C6.03232 12.1025 7.16031 11.9928 8.19573 11.5868C9.23115 11.1809 10.1331 10.4947 10.8006 9.60509C11.4681 8.71551 11.8748 7.65767 11.9751 6.55004C11.9816 6.48041 11.9735 6.4102 11.9513 6.34388C11.9291 6.27756 11.8934 6.21659 11.8463 6.16485C11.7993 6.11311 11.742 6.07173 11.6781 6.04335C11.6142 6.01498 11.545 6.00023 11.4751 6.00004H11.4756Z" fill="currentColor"/>
    </g>
    <defs><clipPath id="clip0_ssb_restart"><rect width="12" height="12" fill="white"/></clipPath></defs>
  </svg>
);

const PowerIcon = () => (
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: 14, height: 14 }}>
    <path d="M6 1V6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
    <path d="M9.5 3.5C10.2 4.3 10.5 5.4 10.3 6.5C10 8.1 8.7 9.4 7.1 9.7C4.6 10.3 2.3 8.6 2 6.2C1.8 4.7 2.5 3.4 3.6 2.7" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
  </svg>
);

const ActionsDropdown = ({ server, onRestartKraken, onRebootServer }) => {
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);
  const dropRef = useRef(null);
  const [pos, setPos] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (
        btnRef.current && !btnRef.current.contains(e.target) &&
        dropRef.current && !dropRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const toggleOpen = (e) => {
    e.stopPropagation();
    if (!open && btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      setPos({ top: rect.bottom + 4, left: rect.right });
    }
    setOpen((v) => !v);
  };

  const handleAction = (action) => {
    setOpen(false);
    if (action === 'restart-kraken' && onRestartKraken) onRestartKraken(server);
    if (action === 'reboot-server' && onRebootServer) onRebootServer(server);
  };

  return (
    <div className="server-summary-block__actions-wrap">
      <button
        ref={btnRef}
        type="button"
        className="pm-action-dots"
        onClick={toggleOpen}
        aria-label="Действия"
        aria-expanded={open}
        tabIndex={0}
      >
        <span className="pm-action-dots__dot" />
        <span className="pm-action-dots__dot" />
        <span className="pm-action-dots__dot" />
      </button>
      {open && ReactDOM.createPortal(
        <div
          ref={dropRef}
          className="pm-action-dropdown--portal"
          style={{ top: pos.top, left: pos.left }}
        >
          <button
            type="button"
            className="pm-action-dropdown--portal__item"
            onClick={() => handleAction('restart-kraken')}
          >
            <RestartIcon />
            <span>Перезагрузить Kraken</span>
          </button>
          <button
            type="button"
            className="pm-action-dropdown--portal__item pm-action-dropdown--portal__item--danger"
            onClick={() => handleAction('reboot-server')}
          >
            <PowerIcon />
            <span>Перезагрузить сервер</span>
          </button>
        </div>,
        document.body
      )}
    </div>
  );
};

/**
 * Блок «Сводка по серверам» по макету Figma 26-04 wa Proxy Manager (node 383-57523).
 * Desktop: горизонтальная таблица
 * Mobile (node 383:60415): вертикальная таблица (карусель серверов), чипы, кнопка перезагрузки
 */
const ServerSummaryBlock = ({
  title = 'Сводка по серверам',
  linkTo = '/servers',
  servers = [],
  loading = false,
  onReboot,
  onRestartKraken,
  onRebootServer,
}) => {
  const navigate = useNavigate();
  const isModifiedClick = (e) => e.metaKey || e.altKey || e.ctrlKey || e.shiftKey;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activeServerIndex, setActiveServerIndex] = useState(0);
  const [activeChip, setActiveChip] = useState('all'); // 'all' | 'unavailable'
  const [expandedRegions, setExpandedRegions] = useState({ spb: false, msk: false });
  const [desktopSort, setDesktopSort] = useState({ key: null, direction: 'desc' });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLinkClick = (e) => {
    if (e.button !== 0 || isModifiedClick(e)) {
      return;
    }
    e.preventDefault();
    navigate(linkTo);
  };

  const handleLinkKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      navigate(linkTo);
    }
  };

  const normalizeGeo = (geo) => String(geo || '').trim().toLowerCase();
  const isSpbGeo = (geo) => ['спб', 'spb'].includes(normalizeGeo(geo));
  const isMskGeo = (geo) => ['мск', 'msk', 'moscow', 'москва'].includes(normalizeGeo(geo));
  const sortServersByName = (serversList = []) =>
    [...serversList].sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''), 'ru'));
  /** Свободные − недоступные − резерв (подключение). */
  const computeForSaleModems = (server) => {
    if (server == null) return 0;
    if (typeof server.forSaleModems === 'number' && Number.isFinite(server.forSaleModems)) {
      return Math.max(0, server.forSaleModems);
    }
    const free = server.freeModems || 0;
    const unavail = server.unavailableModems || 0;
    const reserve = Number(server.reserveModems) || 0;
    return Math.max(0, free - unavail - reserve);
  };

  const getServerSortValue = (server, sortKey) => {
    if (!sortKey) return 0;
    if (sortKey === 'load') return Number(server.load || 0);
    if (sortKey === 'forSaleModems') return computeForSaleModems(server);
    return Number(server[sortKey] || 0);
  };
  const sortServersByActiveColumn = (serversList = []) => {
    if (!desktopSort.key) {
      return sortServersByName(serversList);
    }
    const directionFactor = desktopSort.direction === 'asc' ? 1 : -1;
    return [...serversList].sort((a, b) => {
      const aValue = getServerSortValue(a, desktopSort.key);
      const bValue = getServerSortValue(b, desktopSort.key);
      if (aValue !== bValue) {
        return (aValue - bValue) * directionFactor;
      }
      return String(a.name || '').localeCompare(String(b.name || ''), 'ru');
    });
  };
  const sortServersByGeoAndName = (serversList = []) =>
    [...serversList].sort((a, b) => {
      const aGeoPriority = isSpbGeo(a.geo) ? 0 : isMskGeo(a.geo) ? 1 : 2;
      const bGeoPriority = isSpbGeo(b.geo) ? 0 : isMskGeo(b.geo) ? 1 : 2;
      if (aGeoPriority !== bGeoPriority) {
        return aGeoPriority - bGeoPriority;
      }
      return String(a.name || '').localeCompare(String(b.name || ''), 'ru');
    });
  const orderedServers = sortServersByGeoAndName(servers);

  // Фильтрация серверов по активному чипу
  const filteredServers = activeChip === 'unavailable'
    ? orderedServers.filter((s) => (s.unavailableModems || 0) > 0)
    : orderedServers;

  // Навигация по серверам (карусель)
  const handlePrev = () => {
    setActiveServerIndex((prev) =>
      prev > 0 ? prev - 1 : filteredServers.length - 1
    );
  };

  const handleNext = () => {
    setActiveServerIndex((prev) =>
      prev < filteredServers.length - 1 ? prev + 1 : 0
    );
  };

  // Сброс индекса при смене чипа
  const handleChipClick = (chip) => {
    setActiveChip(chip);
    setActiveServerIndex(0);
  };

  // Кол-во серверов с недоступными модемами
  const unavailableCount = servers.filter(
    (s) => (s.unavailableModems || 0) > 0
  ).length;

  // Расчёт итоговой строки
  const totals = servers.reduce(
    (acc, server) => ({
      totalModems: acc.totalModems + (server.totalModems || 0),
      freeModems: acc.freeModems + (server.freeModems || 0),
      forSaleModems: acc.forSaleModems + computeForSaleModems(server),
      unavailableModems: acc.unavailableModems + (server.unavailableModems || 0),
      totalProxies: acc.totalProxies + (server.totalProxies || 0),
      unavailableProxies: acc.unavailableProxies + (server.unavailableProxies || 0),
    }),
    {
      totalModems: 0,
      freeModems: 0,
      forSaleModems: 0,
      unavailableModems: 0,
      totalProxies: 0,
      unavailableProxies: 0,
    }
  );

  // Итоговая загрузка (взвешенная по ёмкости: sum(allocated_speed) / sum(capacity) * 100)
  const totalAllocatedSpeed = servers.reduce((sum, s) => sum + (s.totalAllocatedSpeed || 0), 0);
  const totalCapacityAll = servers.reduce((sum, s) => sum + (s.totalCapacity || 0), 0);
  const avgLoad = totalCapacityAll > 0
    ? Math.round(Math.min((totalAllocatedSpeed / totalCapacityAll) * 100, 100))
    : 0;

  const getTotalsForRegion = (geoAliases = []) => {
    const normalizedAliases = geoAliases.map((geo) => String(geo || '').toLowerCase());
    const regionServers = servers.filter((server) =>
      normalizedAliases.includes(String(server.geo || '').toLowerCase())
    );

    const regionTotals = regionServers.reduce(
      (acc, server) => ({
        totalModems: acc.totalModems + (server.totalModems || 0),
        freeModems: acc.freeModems + (server.freeModems || 0),
        forSaleModems: acc.forSaleModems + computeForSaleModems(server),
        unavailableModems: acc.unavailableModems + (server.unavailableModems || 0),
        totalProxies: acc.totalProxies + (server.totalProxies || 0),
        unavailableProxies: acc.unavailableProxies + (server.unavailableProxies || 0),
      }),
      {
        totalModems: 0,
        freeModems: 0,
        forSaleModems: 0,
        unavailableModems: 0,
        totalProxies: 0,
        unavailableProxies: 0,
      }
    );

    const regionAllocatedSpeed = regionServers.reduce((sum, s) => sum + (s.totalAllocatedSpeed || 0), 0);
    const regionTotalCapacity = regionServers.reduce((sum, s) => sum + (s.totalCapacity || 0), 0);
    const regionAvgLoad = regionTotalCapacity > 0
      ? Math.round(Math.min((regionAllocatedSpeed / regionTotalCapacity) * 100, 100))
      : 0;

    return { regionServers, regionTotals, regionAvgLoad };
  };

  const spbSummary = getTotalsForRegion(['спб', 'spb']);
  const mskSummary = getTotalsForRegion(['мск', 'msk', 'moscow', 'москва']);
  const sortedSpbServers = sortServersByActiveColumn(servers.filter((server) => isSpbGeo(server.geo)));
  const sortedMskServers = sortServersByActiveColumn(servers.filter((server) => isMskGeo(server.geo)));
  const sortedOtherServers = sortServersByActiveColumn(
    servers.filter((server) => !isSpbGeo(server.geo) && !isMskGeo(server.geo))
  );

  const getLoadBadge = (load) => {
    if (load <= 30) return { label: 'Min', className: 'server-summary-block__badge--green' };
    if (load <= 70) return { label: 'Med', className: 'server-summary-block__badge--yellow' };
    return { label: 'Max', className: 'server-summary-block__badge--red' };
  };

  const [rebootModalServer, setRebootModalServer] = useState(null);

  const handleRebootClick = (server) => {
    setRebootModalServer(server);
  };

  const handleRebootModalClose = () => {
    setRebootModalServer(null);
  };

  const handleRebootModalAction = (action) => {
    const server = rebootModalServer;
    setRebootModalServer(null);
    if (action === 'kraken' && onRestartKraken) onRestartKraken(server);
    if (action === 'server' && onRebootServer) onRebootServer(server);
  };

  const handleToggleRegion = (regionKey) => {
    setExpandedRegions((prev) => ({
      ...prev,
      [regionKey]: !prev[regionKey],
    }));
  };

  const handleRegionKeyDown = (event, regionKey) => {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }
    event.preventDefault();
    handleToggleRegion(regionKey);
  };

  const handleDesktopSort = (sortKey) => {
    setDesktopSort((prev) => {
      if (prev.key !== sortKey) {
        return { key: sortKey, direction: 'desc' };
      }
      return { key: sortKey, direction: prev.direction === 'desc' ? 'asc' : 'desc' };
    });
  };

  const getSortIndicator = (sortKey) => {
    if (desktopSort.key !== sortKey) {
      return '↕';
    }
    return desktopSort.direction === 'desc' ? '↓' : '↑';
  };

  const formatHostCpu = (server) => {
    if (server == null || server.hostCpu == null || Number.isNaN(Number(server.hostCpu))) {
      return '—';
    }
    return `${server.hostCpu}%`;
  };

  const formatHostRam = (server) => {
    if (server == null) return '—';
    if (server.hostMemoryPercent != null && !Number.isNaN(Number(server.hostMemoryPercent))) {
      return `${server.hostMemoryPercent}%`;
    }
    return '—';
  };

  const hostResourceTitle = (server) => {
    const parts = [];
    if (server?.hostMemoryLabel) parts.push(server.hostMemoryLabel);
    if (server?.hostUptimeHumanize) parts.push(`uptime: ${server.hostUptimeHumanize}`);
    return parts.length ? parts.join(' · ') : undefined;
  };

  // ==================== MOBILE VIEW ====================
  if (isMobile) {
    const currentServer = filteredServers[activeServerIndex] || null;

    return (
      <section className="server-summary-block" aria-label={`Блок: ${title}`}>
        {/* Title с стрелками навигации */}
        <div className="server-summary-block__title">
          <h2 className="server-summary-block__title-text">{title}</h2>
          <button
            type="button"
            className="server-summary-block__nav-btn"
            onClick={handlePrev}
            aria-label="Предыдущий сервер"
            tabIndex={0}
          >
            <LeftOutlined />
          </button>
          <button
            type="button"
            className="server-summary-block__nav-btn"
            onClick={handleNext}
            aria-label="Следующий сервер"
            tabIndex={0}
          >
            <RightOutlined />
          </button>
        </div>

        {/* Chips */}
        <div className="server-summary-block__chips">
          <button
            type="button"
            className={`server-summary-block__chip ${
              activeChip === 'all' ? 'server-summary-block__chip--active' : ''
            }`}
            onClick={() => handleChipClick('all')}
            tabIndex={0}
          >
            <span className="server-summary-block__chip-label">Все</span>
            <span className="server-summary-block__chip-count">
              {servers.length}
            </span>
          </button>
          <button
            type="button"
            className={`server-summary-block__chip ${
              activeChip === 'unavailable'
                ? 'server-summary-block__chip--active'
                : ''
            }`}
            onClick={() => handleChipClick('unavailable')}
            tabIndex={0}
          >
            <span className="server-summary-block__chip-label">
              Недоступные модемы
            </span>
            <span className="server-summary-block__chip-count">
              {unavailableCount}
            </span>
          </button>
        </div>

        {/* Vertical table */}
        {currentServer ? (
          <>
            <div className="server-summary-block__mobile-table-wrap">
              <table className="server-summary-block__mobile-table">
                <tbody>
                  <tr>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--header">
                      Сервер
                    </td>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--value server-summary-block__mobile-cell--bold">
                      {filteredServers.length}
                    </td>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--server">
                      {currentServer.name}
                    </td>
                  </tr>
                  <tr>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--label">
                      Гео
                    </td>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--muted">
                      -
                    </td>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--muted">
                      {currentServer.geo || '-'}
                    </td>
                  </tr>
                  <tr>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--label">
                      Модемы
                    </td>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--muted server-summary-block__mobile-cell--bold">
                      {totals.totalModems}
                    </td>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--muted">
                      {currentServer.totalModems}
                    </td>
                  </tr>
                  <tr>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--label server-summary-block__mobile-cell--sub">
                      · свободные
                    </td>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--green">
                      {totals.freeModems}
                    </td>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--green">
                      {currentServer.freeModems}
                    </td>
                  </tr>
                  <tr>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--label server-summary-block__mobile-cell--sub">
                      · в продаже
                    </td>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--green">
                      {totals.forSaleModems}
                    </td>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--green">
                      {computeForSaleModems(currentServer)}
                    </td>
                  </tr>
                  <tr>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--label server-summary-block__mobile-cell--sub">
                      · недоступные
                    </td>
                    <td className={`server-summary-block__mobile-cell ${totals.unavailableModems === 0 ? 'server-summary-block__mobile-cell--green' : 'server-summary-block__mobile-cell--red'}`}>
                      {totals.unavailableModems}
                    </td>
                    <td className={`server-summary-block__mobile-cell ${(currentServer.unavailableModems || 0) === 0 ? 'server-summary-block__mobile-cell--green' : 'server-summary-block__mobile-cell--red'}`}>
                      {currentServer.unavailableModems}
                    </td>
                  </tr>
                  <tr>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--label">
                      Прокси
                    </td>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--muted server-summary-block__mobile-cell--bold">
                      {totals.totalProxies}
                    </td>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--muted">
                      {currentServer.totalProxies}
                    </td>
                  </tr>
                  <tr>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--label server-summary-block__mobile-cell--sub">
                      · недоступные
                    </td>
                    <td className={`server-summary-block__mobile-cell ${totals.unavailableProxies === 0 ? 'server-summary-block__mobile-cell--green' : 'server-summary-block__mobile-cell--red'}`}>
                      {totals.unavailableProxies}
                    </td>
                    <td className={`server-summary-block__mobile-cell ${(currentServer.unavailableProxies || 0) === 0 ? 'server-summary-block__mobile-cell--green' : 'server-summary-block__mobile-cell--red'}`}>
                      {currentServer.unavailableProxies}
                    </td>
                  </tr>
                  <tr>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--label">
                      CPU (хост)
                    </td>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--muted">
                      -
                    </td>
                    <td
                      className="server-summary-block__mobile-cell server-summary-block__mobile-cell--muted"
                      title={hostResourceTitle(currentServer)}
                    >
                      {formatHostCpu(currentServer)}
                    </td>
                  </tr>
                  <tr>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--label">
                      ОЗУ (хост)
                    </td>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--muted">
                      -
                    </td>
                    <td
                      className="server-summary-block__mobile-cell server-summary-block__mobile-cell--muted"
                      title={hostResourceTitle(currentServer)}
                    >
                      {formatHostRam(currentServer)}
                    </td>
                  </tr>
                  <tr>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--label">
                      Загрузка
                    </td>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--muted">
                      -
                    </td>
                    <td className="server-summary-block__mobile-cell server-summary-block__mobile-cell--muted">
                      <span className={`server-summary-block__badge ${getLoadBadge(currentServer.load || 0).className}`}>
                        {getLoadBadge(currentServer.load || 0).label}
                      </span>
                      {' '}
                      {currentServer.load || 0}%
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Reboot button */}
            <button
              type="button"
              className="server-summary-block__reboot-btn"
              onClick={() => handleRebootClick(currentServer)}
              aria-label={`Перезагрузить ${currentServer.name}`}
              tabIndex={0}
            >
              Перезагрузить {currentServer.name}
              <ReloadOutlined style={{ fontSize: 18 }} />
            </button>

            {/* Reboot type modal */}
            {rebootModalServer && ReactDOM.createPortal(
              <div
                className="server-summary-block__reboot-overlay"
                onClick={handleRebootModalClose}
                role="dialog"
                aria-modal="true"
                aria-label="Выберите тип перезагрузки"
              >
                <div
                  className="server-summary-block__reboot-modal"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="server-summary-block__reboot-modal-title">
                    Перезагрузка — {rebootModalServer.name}
                  </div>
                  <button
                    type="button"
                    className="server-summary-block__reboot-modal-btn"
                    onClick={() => handleRebootModalAction('kraken')}
                    tabIndex={0}
                  >
                    <RestartIcon />
                    <span>Перезагрузить Kraken</span>
                  </button>
                  <button
                    type="button"
                    className="server-summary-block__reboot-modal-btn server-summary-block__reboot-modal-btn--danger"
                    onClick={() => handleRebootModalAction('server')}
                    tabIndex={0}
                  >
                    <PowerIcon />
                    <span>Перезагрузить сервер</span>
                  </button>
                  <button
                    type="button"
                    className="server-summary-block__reboot-modal-cancel"
                    onClick={handleRebootModalClose}
                    tabIndex={0}
                  >
                    Отмена
                  </button>
                </div>
              </div>,
              document.body
            )}
          </>
        ) : (
          <div className="server-summary-block__empty">
            {loading ? 'Данные загружаются...' : 'Нет серверов'}
          </div>
        )}
      </section>
    );
  }

  // ==================== DESKTOP VIEW ====================
  return (
    <section className="server-summary-block" aria-label={`Блок: ${title}`}>
      <div className="server-summary-block__title">
        <h2 className="server-summary-block__title-text">{title}</h2>
        <a
          href={linkTo}
          className="server-summary-block__btn"
          onClick={handleLinkClick}
          onKeyDown={handleLinkKeyDown}
          tabIndex={0}
          aria-label={`Перейти в раздел ${title}`}
        >
          В раздел
          <svg
            className="server-summary-block__btn-icon"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M4.5 3L7.5 6L4.5 9"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
      </div>

      <div className="server-summary-block__table-wrap">
        <table className="server-summary-block__table">
          <colgroup>
            <col />
            <col className="server-summary-block__col--fixed" />
            <col className="server-summary-block__col--fixed" />
            <col className="server-summary-block__col--fixed" />
            <col className="server-summary-block__col--fixed" />
            <col className="server-summary-block__col--fixed" />
            <col className="server-summary-block__col--fixed" />
            <col className="server-summary-block__col--fixed" />
            <col className="server-summary-block__col--host-metric" />
            <col className="server-summary-block__col--host-metric" />
            <col className="server-summary-block__col--load" />
            <col className="server-summary-block__col--actions" />
          </colgroup>
          <thead>
            <tr className="server-summary-block__row server-summary-block__row--header">
              <th className="server-summary-block__cell server-summary-block__cell--header">Сервер</th>
              <th className="server-summary-block__cell server-summary-block__cell--header">ГЕО</th>
              <th className="server-summary-block__cell server-summary-block__cell--header">
                <button type="button" className="server-summary-block__sort-btn" onClick={() => handleDesktopSort('totalModems')}>
                  Модемы
                  <span className="server-summary-block__sort-indicator">{getSortIndicator('totalModems')}</span>
                </button>
              </th>
              <th className="server-summary-block__cell server-summary-block__cell--header">
                <button type="button" className="server-summary-block__sort-btn" onClick={() => handleDesktopSort('freeModems')}>
                  Свободные
                  <span className="server-summary-block__sort-indicator">{getSortIndicator('freeModems')}</span>
                </button>
              </th>
              <th
                className="server-summary-block__cell server-summary-block__cell--header"
                title="Свободные − недоступные − резерв (настройка подключения)"
              >
                <button type="button" className="server-summary-block__sort-btn" onClick={() => handleDesktopSort('forSaleModems')}>
                  В продаже
                  <span className="server-summary-block__sort-indicator">{getSortIndicator('forSaleModems')}</span>
                </button>
              </th>
              <th className="server-summary-block__cell server-summary-block__cell--header">
                <button type="button" className="server-summary-block__sort-btn" onClick={() => handleDesktopSort('unavailableModems')}>
                  Недоступные
                  <span className="server-summary-block__sort-indicator">{getSortIndicator('unavailableModems')}</span>
                </button>
              </th>
              <th className="server-summary-block__cell server-summary-block__cell--header">
                <button type="button" className="server-summary-block__sort-btn" onClick={() => handleDesktopSort('totalProxies')}>
                  Прокси
                  <span className="server-summary-block__sort-indicator">{getSortIndicator('totalProxies')}</span>
                </button>
              </th>
              <th className="server-summary-block__cell server-summary-block__cell--header">
                <button type="button" className="server-summary-block__sort-btn" onClick={() => handleDesktopSort('unavailableProxies')}>
                  Недоступные
                  <span className="server-summary-block__sort-indicator">{getSortIndicator('unavailableProxies')}</span>
                </button>
              </th>
              <th className="server-summary-block__cell server-summary-block__cell--header" title="Kraken GET /dashboard/cpu">
                CPU
              </th>
              <th className="server-summary-block__cell server-summary-block__cell--header" title="Kraken GET /dashboard/cpu">
                ОЗУ
              </th>
              <th className="server-summary-block__cell server-summary-block__cell--header">
                <button type="button" className="server-summary-block__sort-btn" onClick={() => handleDesktopSort('load')}>
                  Загрузка сервера
                  <span className="server-summary-block__sort-indicator">{getSortIndicator('load')}</span>
                </button>
              </th>
              <th className="server-summary-block__cell server-summary-block__cell--header server-summary-block__cell--actions">
                <span className="server-summary-block__kebab" aria-hidden="true">
                  <span className="server-summary-block__kebab-dot" />
                  <span className="server-summary-block__kebab-dot" />
                  <span className="server-summary-block__kebab-dot" />
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {loading && servers.length === 0 ? (
              <tr className="server-summary-block__row">
                <td colSpan={12} className="server-summary-block__cell server-summary-block__cell--muted" style={{ textAlign: 'center', padding: '1.5rem' }}>
                  Данные загружаются...
                </td>
              </tr>
            ) : (
            <>
            {/* Итоговая строка */}
            <tr className="server-summary-block__row server-summary-block__row--total">
              <td className="server-summary-block__cell server-summary-block__cell--bold">
                Итого ({servers.length})
              </td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">-</td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">{totals.totalModems}</td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">{totals.freeModems}</td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">{totals.forSaleModems}</td>
              <td className={`server-summary-block__cell ${totals.unavailableModems === 0 ? 'server-summary-block__cell--success' : 'server-summary-block__cell--error'}`}>{totals.unavailableModems}</td>
              <td className="server-summary-block__cell">{totals.totalProxies}</td>
              <td className={`server-summary-block__cell ${totals.unavailableProxies === 0 ? 'server-summary-block__cell--success' : 'server-summary-block__cell--error'}`}>{totals.unavailableProxies}</td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">—</td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">—</td>
              <td className="server-summary-block__cell">
                <div className="server-summary-block__load-content">
                  <span className={`server-summary-block__badge ${getLoadBadge(avgLoad).className}`}>
                    {getLoadBadge(avgLoad).label}
                  </span>
                  <span className="server-summary-block__load-value">{avgLoad}%</span>
                </div>
              </td>
              <td className="server-summary-block__cell server-summary-block__cell--actions" />
            </tr>
            <tr
              className={`server-summary-block__row server-summary-block__row--total server-summary-block__row--expandable ${expandedRegions.spb ? 'server-summary-block__row--expanded' : ''}`}
              onClick={() => handleToggleRegion('spb')}
              onKeyDown={(event) => handleRegionKeyDown(event, 'spb')}
              role="button"
              tabIndex={0}
              aria-label="Показать серверы СПб"
              aria-expanded={expandedRegions.spb}
            >
              <td className="server-summary-block__cell server-summary-block__cell--bold">
                <span className={`server-summary-block__toggle-indicator ${expandedRegions.spb ? 'server-summary-block__toggle-indicator--expanded' : ''}`}>
                  ▸
                </span>
                Итого СПб ({spbSummary.regionServers.length})
              </td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">СПб</td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">{spbSummary.regionTotals.totalModems}</td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">{spbSummary.regionTotals.freeModems}</td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">{spbSummary.regionTotals.forSaleModems}</td>
              <td className={`server-summary-block__cell ${spbSummary.regionTotals.unavailableModems === 0 ? 'server-summary-block__cell--success' : 'server-summary-block__cell--error'}`}>{spbSummary.regionTotals.unavailableModems}</td>
              <td className="server-summary-block__cell">{spbSummary.regionTotals.totalProxies}</td>
              <td className={`server-summary-block__cell ${spbSummary.regionTotals.unavailableProxies === 0 ? 'server-summary-block__cell--success' : 'server-summary-block__cell--error'}`}>{spbSummary.regionTotals.unavailableProxies}</td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">—</td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">—</td>
              <td className="server-summary-block__cell">
                <div className="server-summary-block__load-content">
                  <span className={`server-summary-block__badge ${getLoadBadge(spbSummary.regionAvgLoad).className}`}>
                    {getLoadBadge(spbSummary.regionAvgLoad).label}
                  </span>
                  <span className="server-summary-block__load-value">{spbSummary.regionAvgLoad}%</span>
                </div>
              </td>
              <td className="server-summary-block__cell server-summary-block__cell--actions" />
            </tr>
            {expandedRegions.spb && sortedSpbServers.map((server, index) => {
              const loadBadge = getLoadBadge(server.load || 0);
              return (
                <tr key={`spb-${server.id || index}`} className="server-summary-block__row server-summary-block__row--animated">
                  <td className="server-summary-block__cell server-summary-block__cell--muted">
                    {server.name}
                  </td>
                  <td className="server-summary-block__cell server-summary-block__cell--dark">{server.geo || '-'}</td>
                  <td className="server-summary-block__cell server-summary-block__cell--dark">{server.totalModems}</td>
                  <td className="server-summary-block__cell server-summary-block__cell--dark">{server.freeModems}</td>
                  <td className="server-summary-block__cell server-summary-block__cell--dark">{computeForSaleModems(server)}</td>
                  <td className={`server-summary-block__cell ${(server.unavailableModems || 0) === 0 ? 'server-summary-block__cell--success' : 'server-summary-block__cell--error'}`}>{server.unavailableModems}</td>
                  <td className="server-summary-block__cell server-summary-block__cell--dark">{server.totalProxies}</td>
                  <td className={`server-summary-block__cell ${(server.unavailableProxies || 0) === 0 ? 'server-summary-block__cell--success' : 'server-summary-block__cell--error'}`}>{server.unavailableProxies}</td>
                  <td
                    className="server-summary-block__cell server-summary-block__cell--dark"
                    title={hostResourceTitle(server)}
                  >
                    {formatHostCpu(server)}
                  </td>
                  <td
                    className="server-summary-block__cell server-summary-block__cell--dark"
                    title={hostResourceTitle(server)}
                  >
                    {formatHostRam(server)}
                  </td>
                  <td className="server-summary-block__cell">
                    <div className="server-summary-block__load-content">
                      <span className={`server-summary-block__badge ${loadBadge.className}`}>
                        {loadBadge.label}
                      </span>
                      <span className="server-summary-block__load-value server-summary-block__load-value--muted">
                        {server.load || 0}%
                      </span>
                    </div>
                  </td>
                  <td className="server-summary-block__cell server-summary-block__cell--actions">
                    <ActionsDropdown
                      server={server}
                      onRestartKraken={onRestartKraken}
                      onRebootServer={onRebootServer}
                    />
                  </td>
                </tr>
              );
            })}
            <tr
              className={`server-summary-block__row server-summary-block__row--total server-summary-block__row--expandable ${expandedRegions.msk ? 'server-summary-block__row--expanded' : ''}`}
              onClick={() => handleToggleRegion('msk')}
              onKeyDown={(event) => handleRegionKeyDown(event, 'msk')}
              role="button"
              tabIndex={0}
              aria-label="Показать серверы Мск"
              aria-expanded={expandedRegions.msk}
            >
              <td className="server-summary-block__cell server-summary-block__cell--bold">
                <span className={`server-summary-block__toggle-indicator ${expandedRegions.msk ? 'server-summary-block__toggle-indicator--expanded' : ''}`}>
                  ▸
                </span>
                Итого Мск ({mskSummary.regionServers.length})
              </td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">Мск</td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">{mskSummary.regionTotals.totalModems}</td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">{mskSummary.regionTotals.freeModems}</td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">{mskSummary.regionTotals.forSaleModems}</td>
              <td className={`server-summary-block__cell ${mskSummary.regionTotals.unavailableModems === 0 ? 'server-summary-block__cell--success' : 'server-summary-block__cell--error'}`}>{mskSummary.regionTotals.unavailableModems}</td>
              <td className="server-summary-block__cell">{mskSummary.regionTotals.totalProxies}</td>
              <td className={`server-summary-block__cell ${mskSummary.regionTotals.unavailableProxies === 0 ? 'server-summary-block__cell--success' : 'server-summary-block__cell--error'}`}>{mskSummary.regionTotals.unavailableProxies}</td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">—</td>
              <td className="server-summary-block__cell server-summary-block__cell--dark">—</td>
              <td className="server-summary-block__cell">
                <div className="server-summary-block__load-content">
                  <span className={`server-summary-block__badge ${getLoadBadge(mskSummary.regionAvgLoad).className}`}>
                    {getLoadBadge(mskSummary.regionAvgLoad).label}
                  </span>
                  <span className="server-summary-block__load-value">{mskSummary.regionAvgLoad}%</span>
                </div>
              </td>
              <td className="server-summary-block__cell server-summary-block__cell--actions" />
            </tr>
            {expandedRegions.msk && sortedMskServers.map((server, index) => {
              const loadBadge = getLoadBadge(server.load || 0);
              return (
                <tr key={`msk-${server.id || index}`} className="server-summary-block__row server-summary-block__row--animated">
                  <td className="server-summary-block__cell server-summary-block__cell--muted">
                    {server.name}
                  </td>
                  <td className="server-summary-block__cell server-summary-block__cell--dark">{server.geo || '-'}</td>
                  <td className="server-summary-block__cell server-summary-block__cell--dark">{server.totalModems}</td>
                  <td className="server-summary-block__cell server-summary-block__cell--dark">{server.freeModems}</td>
                  <td className="server-summary-block__cell server-summary-block__cell--dark">{computeForSaleModems(server)}</td>
                  <td className={`server-summary-block__cell ${(server.unavailableModems || 0) === 0 ? 'server-summary-block__cell--success' : 'server-summary-block__cell--error'}`}>{server.unavailableModems}</td>
                  <td className="server-summary-block__cell server-summary-block__cell--dark">{server.totalProxies}</td>
                  <td className={`server-summary-block__cell ${(server.unavailableProxies || 0) === 0 ? 'server-summary-block__cell--success' : 'server-summary-block__cell--error'}`}>{server.unavailableProxies}</td>
                  <td
                    className="server-summary-block__cell server-summary-block__cell--dark"
                    title={hostResourceTitle(server)}
                  >
                    {formatHostCpu(server)}
                  </td>
                  <td
                    className="server-summary-block__cell server-summary-block__cell--dark"
                    title={hostResourceTitle(server)}
                  >
                    {formatHostRam(server)}
                  </td>
                  <td className="server-summary-block__cell">
                    <div className="server-summary-block__load-content">
                      <span className={`server-summary-block__badge ${loadBadge.className}`}>
                        {loadBadge.label}
                      </span>
                      <span className="server-summary-block__load-value server-summary-block__load-value--muted">
                        {server.load || 0}%
                      </span>
                    </div>
                  </td>
                  <td className="server-summary-block__cell server-summary-block__cell--actions">
                    <ActionsDropdown
                      server={server}
                      onRestartKraken={onRestartKraken}
                      onRebootServer={onRebootServer}
                    />
                  </td>
                </tr>
              );
            })}
            {sortedOtherServers.map((server, index) => {
              const loadBadge = getLoadBadge(server.load || 0);
              return (
                <tr key={`other-${server.id || index}`} className="server-summary-block__row">
                  <td className="server-summary-block__cell server-summary-block__cell--muted">
                    {server.name}
                  </td>
                  <td className="server-summary-block__cell server-summary-block__cell--dark">{server.geo || '-'}</td>
                  <td className="server-summary-block__cell server-summary-block__cell--dark">{server.totalModems}</td>
                  <td className="server-summary-block__cell server-summary-block__cell--dark">{server.freeModems}</td>
                  <td className="server-summary-block__cell server-summary-block__cell--dark">{computeForSaleModems(server)}</td>
                  <td className={`server-summary-block__cell ${(server.unavailableModems || 0) === 0 ? 'server-summary-block__cell--success' : 'server-summary-block__cell--error'}`}>{server.unavailableModems}</td>
                  <td className="server-summary-block__cell server-summary-block__cell--dark">{server.totalProxies}</td>
                  <td className={`server-summary-block__cell ${(server.unavailableProxies || 0) === 0 ? 'server-summary-block__cell--success' : 'server-summary-block__cell--error'}`}>{server.unavailableProxies}</td>
                  <td
                    className="server-summary-block__cell server-summary-block__cell--dark"
                    title={hostResourceTitle(server)}
                  >
                    {formatHostCpu(server)}
                  </td>
                  <td
                    className="server-summary-block__cell server-summary-block__cell--dark"
                    title={hostResourceTitle(server)}
                  >
                    {formatHostRam(server)}
                  </td>
                  <td className="server-summary-block__cell">
                    <div className="server-summary-block__load-content">
                      <span className={`server-summary-block__badge ${loadBadge.className}`}>
                        {loadBadge.label}
                      </span>
                      <span className="server-summary-block__load-value server-summary-block__load-value--muted">
                        {server.load || 0}%
                      </span>
                    </div>
                  </td>
                  <td className="server-summary-block__cell server-summary-block__cell--actions">
                    <ActionsDropdown
                      server={server}
                      onRestartKraken={onRestartKraken}
                      onRebootServer={onRebootServer}
                    />
                  </td>
                </tr>
              );
            })}
            </>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default ServerSummaryBlock;
